var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect } from 'react';
import { makeStyles, Container, Dialog, DialogTitle, DialogActions, DialogButton } from "../../../index";
import { useUseCase } from "../../../hooks/useUseCase";
import { useTranslation } from "../../../hooks/useTranslation";
import { omit } from "../../../utils/omit";
import { initialUserSelectDialogState } from "./UserSelectDialogState";
import { UserSelectDialogToolbar } from "./components/UserSelectDialogToolbar";
import { UserSelectDialogContent } from "./components/UserSelectDialogContent";
import { UserSelectDialogSelectedInfo } from "./components/UserSelectDialogSelectedInfo";
import { SelectOrganizationUseCase } from "./usecases/SelectOrganizationUseCase";
import { SelectUserUseCase } from "./usecases/SelectUserUseCase";
import { UnselectUserUseCase } from "./usecases/UnselectUserUseCase";
import { OpenUserSelectDialogUseCase } from "./usecases/OpenUserSelectDialogUseCase";
import { CloseUserSelectDialogUseCase } from "./usecases/CloseUserSelectDialogUseCase";
import { SelectAllUsersUseCase } from "./usecases/SelectAllUsersUseCase";
import { UnselectAllUsersUseCase } from "./usecases/UnselectAllUsersUseCase";
var useStyles = makeStyles(function () { return ({
    root: {},
    container: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        overflow: 'hidden',
    },
}); });
export var UserSelectDialog = function (props) {
    var open = props.open, mode = props.mode, limit = props.limit, defaultUsers = props.defaultUsers, readonlyDefaultUsers = props.readonlyDefaultUsers, onSelect = props.onSelect, onCancel = props.onCancel, others = __rest(props, ["open", "mode", "limit", "defaultUsers", "readonlyDefaultUsers", "onSelect", "onCancel"]);
    var _a = useUseCase(initialUserSelectDialogState), state = _a.state, usecase = _a.usecase;
    var t = useTranslation().t;
    var classes = useStyles();
    useEffect(function () {
        // prettier-ignore
        open
            ? usecase(new OpenUserSelectDialogUseCase()).execute({ mode: mode, limit: limit, defaultUsers: defaultUsers, readonlyDefaultUsers: readonlyDefaultUsers })
            : usecase(new CloseUserSelectDialogUseCase()).execute();
    }, [usecase, open, mode, limit, defaultUsers, readonlyDefaultUsers]);
    var handleCancel = useCallback(function () {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [onCancel]);
    var handleSelect = useCallback(function () {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(state.selectedUsers.map(function (user) { return (__assign(__assign({}, user), { organization: omit(user.organization, 'type') })); }));
    }, [onSelect, state.selectedUsers]);
    var handleSelectOrganization = useCallback(function (organization) {
        usecase(new SelectOrganizationUseCase()).execute(organization.id);
    }, [usecase]);
    var handleSelectAllUsers = useCallback(function () {
        usecase(new SelectAllUsersUseCase()).execute();
    }, [usecase]);
    var handleUnselectAllUsers = useCallback(function () {
        usecase(new UnselectAllUsersUseCase()).execute();
    }, [usecase]);
    var handleSelectUser = useCallback(function (user, selected) {
        // prettier-ignore
        selected
            ? usecase(new UnselectUserUseCase()).execute(user)
            : usecase(new SelectUserUseCase()).execute(user);
    }, [usecase]);
    return (React.createElement(Dialog, __assign({ className: classes.root, open: open, fullScreen: true }, others),
        React.createElement(DialogTitle, null, t('ユーザーを選ぶ')),
        React.createElement(Container, { className: classes.container },
            React.createElement(UserSelectDialogToolbar, { showSelectAll: state.isMultiSelectMode, organizations: state.organizations, selectedOrganization: state.selectedOrganization, onSelectOrganization: handleSelectOrganization, onSelectAllUsers: handleSelectAllUsers, onUnselectAllUsers: handleUnselectAllUsers }),
            React.createElement(UserSelectDialogContent, { users: state.currentOrganizationUsers, onSelectUser: handleSelectUser }),
            React.createElement(UserSelectDialogSelectedInfo, { limit: state.limit, isExceedLimit: state.isExceedLimit, selectedUsersCount: state.selectedUsersCount, organizations: state.currentOrganizations })),
        React.createElement(DialogActions, null,
            React.createElement(DialogButton, { onClick: handleCancel }, t('キャンセル')),
            React.createElement(DialogButton, { fill: true, onClick: handleSelect, disabled: state.isExceedLimit }, t('選ぶ')))));
};
